/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconCheck from '@telus-uds/palette-koodo/build/rn/icons/Check'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { backgroundColor: '#c9c8c8', switchColor: '#666666' }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#c9c8c8', switchColor: '#595959' }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        outerBorderColor: '#000000',
        outerBorderGap: 3,
        outerBorderWidth: 1,
        switchColor: '#666666'
      }
    },
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#fafafa',
        icon: PaletteIconCheck,
        iconColor: '#ffffff',
        switchBorderColor: 'rgba(0, 0, 0, 0)',
        switchColor: '#000000'
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: { backgroundColor: '#c9c8c8', switchColor: '#404040' }
    },
    {
      if: { pressed: true, selected: true },
      tokens: { backgroundColor: '#c9c8c8', switchColor: '#666666' }
    },
    {
      if: { focus: true, selected: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        icon: PaletteIconCheck,
        iconColor: '#ffffff',
        outerBorderColor: '#000000',
        outerBorderWidth: 1,
        switchBorderColor: 'rgba(0, 0, 0, 0)',
        switchColor: '#000000'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        outerBorderColor: '#000000',
        outerBorderGap: 3,
        outerBorderWidth: 1
      }
    },
    {
      if: { focus: true, pressed: true, selected: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        icon: PaletteIconCheck,
        iconColor: '#ffffff',
        outerBorderColor: '#000000',
        outerBorderGap: 3,
        outerBorderWidth: 1,
        switchColor: '#666666'
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        opacity: 0.5,
        switchBorderColor: 'rgba(0, 0, 0, 0)',
        switchColor: '#c9c8c8'
      }
    },
    {
      if: { inactive: true, selected: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        icon: PaletteIconCheck,
        iconColor: '#ffffff',
        opacity: 0.5,
        switchBorderColor: 'rgba(0, 0, 0, 0)',
        switchColor: '#c9c8c8'
      }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#c9c8c8',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    borderWidth: 0,
    containerWidth: null,
    icon: null,
    iconColor: null,
    iconSize: 12,
    labelColor: '#000000',
    labelFontName: 'StagSans',
    labelFontSize: 16,
    labelFontWeight: '600',
    labelLineHeight: 1.5,
    labelMarginLeft: 0,
    mobileSwitchSize: 24,
    mobileTrackBorderWidth: 4,
    mobileTrackHeight: 32,
    mobileWidth: 48,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 0,
    outerBorderGapButton: 4,
    outerBorderWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    shadow: null,
    space: 2,
    switchBorderColor: 'rgba(0, 0, 0, 0)',
    switchBorderRadius: 32,
    switchBorderWidth: 0,
    switchColor: '#595959',
    switchShadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.2)',
      inset: false,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    },
    switchSize: 24,
    trackBorderColor: 'rgba(0, 0, 0, 0)',
    trackBorderRadius: 12,
    trackBorderWidth: 3,
    trackHeight: 20,
    width: 40
  }
}
export default theme
